// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  height: 100px;
  width: 100%;
  max-width: 220px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
}

#footer {
  background-color: #267833;
  color: white;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.25rem 0;
}

.deleteButton {
  background-color: white;
  color: red;
}

.editButton {
  background-color: white;
}

#addTruffleButton {
  background-color: orange;
  position: fixed;
  bottom: 140px;
  right: 10px;
}

#treeContainer {
  width: 100%;
  position: relative;
  padding-bottom: 8rem; /* leave room to scroll past the fixed footer and floating buttons */
  box-sizing: border-box;
}

.tree-actions {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  right: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  z-index: 10;
}

.tree-actions .deleteButton {
  margin-right: auto;
}

.line {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 0 4rem;
  align-items: center;
  text-align: center;
}

.line app-yearly-yield-list {
  margin-top: 0.25rem;
  width: 100%;
  max-width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/app/field/line/tree/tree.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB,EAAE,oEAAoE;EAC1F,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["img {\n  height: 100px;\n  width: 100%;\n  max-width: 220px;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto;\n}\n\n#footer {\n  background-color: #267833;\n  color: white;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 0.25rem 0;\n}\n\n.deleteButton {\n  background-color: white;\n  color: red;\n}\n\n.editButton {\n  background-color: white;\n}\n\n#addTruffleButton {\n  background-color: orange;\n  position: fixed;\n  bottom: 140px;\n  right: 10px;\n}\n\n#treeContainer {\n  width: 100%;\n  position: relative;\n  padding-bottom: 8rem; /* leave room to scroll past the fixed footer and floating buttons */\n  box-sizing: border-box;\n}\n\n.tree-actions {\n  position: absolute;\n  top: 0.75rem;\n  left: 0.75rem;\n  right: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  z-index: 10;\n}\n\n.tree-actions .deleteButton {\n  margin-right: auto;\n}\n\n.line {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1rem 0 4rem;\n  align-items: center;\n  text-align: center;\n}\n\n.line app-yearly-yield-list {\n  margin-top: 0.25rem;\n  width: 100%;\n  max-width: 240px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
